export const ADD_USER = 'ADD_USER';
export const ADD_ANIMAL ='ADD_ANIMAL';

export function addUser(user) {
    return {
        type: ADD_USER,
        user,
    }
}

export function addAnimal(animal) {
    return {
        type: ADD_ANIMAL,
        animal,
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions.js